import * as React from 'react'
import { IEventHistoryItem } from '../../../Model/TroubleEvent'
import LocalizationStore from '../../../Stores/LocalizationStore'
import { observer } from 'mobx-react'
import { toJS } from 'mobx'
import EventHistoryItemView from '../TroubleEvent/EventHistoryItemView'
import * as _ from 'lodash'

export interface IQuestionnaireEventHistoryViewProps {
    history: Array<IEventHistoryItem>
}

@observer
export default class QuestionnaireEventHistoryView
    extends React.Component<IQuestionnaireEventHistoryViewProps> {
    
        render() {
        let { history } = this.props
        history = toJS(history)

        if (!history || !history.length) {
            return (
                <div />
            )
        }

        const ls = LocalizationStore.getInstance()

        return (
            <div className="rjsf blockTroubleEventHistory col-12">
                <div className="field">
                    <fieldset>
                        <legend>{ls.t!('Event history')}</legend>
                        {
                            _.orderBy(history, ['createDate'], ['desc']).map(x => {
                                return <EventHistoryItemView key={x.id} historyItem={x} />
                            })
                        }
                    </fieldset>
                </div>
            </div>)
    }
}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/Views/PartialViews/Questionnaire/QuestionnaireEventHistoryView.tsx